module.exports = __webpack_public_path__ + "img/kxsx@2x.e6a59a21.png";